<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Provedor', 'Mensagem fora do horário', 'Qtd. horários']"
            :showNew="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Edit="onEdit"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.provedor ? obj.provedor.name : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="truncate(obj.mensagemForaHorario, 50)" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="1" :value="obj.horarios ? obj.horarios.length : 0" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-smx" v-on:click="$emit('New')" v-b-tooltip.hover
          :title="'Clique para cadastrar'">
          <i class="fas fa-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ConfiguracaoBotRepository from '@/shared/http/repositories/configurations/configuracaoBot.js'

export default {
  name: 'ConfiguracaoBotList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      ConfiguracaoBotRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(this.onResultGrid)
        .catch(this.onException)
    },
    truncate (text, max) {
      if (!text) return ''
      return text.length <= max ? text : text.substring(0, max) + '...'
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      ConfiguracaoBotRepository.Delete(obj.id)
        .then(() => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/configuracaoBot/components/list/configuracaoBotConfigList.vue